import { useMutation, useQueryClient } from '@tanstack/react-query';

// Every partner-scoped query cache (companies AND commons) may be stale after switching company —
// some query keys aren't scoped by partner/geogroup id, so a targeted invalidation would miss
// them. Invalidate everything rather than track down each one.
function useSwitchCompanyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => undefined,
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
}

export default useSwitchCompanyMutation;
